import { Component, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from 'src/app/http.service';
import { NgForm } from '@angular/forms';
import { TableComponent } from '../table/table.component';

@Component({
  selector: 'app-topup-withdraw-form',
  templateUrl: './topup-withdraw-form.component.html',
  styleUrls: ['./topup-withdraw-form.component.scss']
})
export class TopupWithdrawFormComponent {

  public data: any = {};
  public transaction: any = {};
  public summary: any = {};
  public setting: any = {};
  public player_id_data: any = {};
  public banks: any = [];
  public games: any = [];
  public player_ids: any = [];
  public active_player_ids: any = [];
  public histories: any = [];
  public player_uuid;
  public permission: any = {};
  public is_loading = true;
  @ViewChild('f') f: NgForm
  @ViewChild('playerForm') playerForm: NgForm
  public transaction_loading = false;
  private referral_rate: any = 0;
  public show_generate_code = false;
  public sections: any = [];
  public deletePlayerEnabled: boolean = false;
  public initial_tab: string = 'bank';

  constructor(private http: HttpService, private route: ActivatedRoute, private cdr: ChangeDetectorRef) {
    this.permission = this.http.getSelecetdCompanyDetail();

    const uuid: Observable<string> = this.route.params.pipe(map(p => p['uuid']));

    uuid.subscribe(val => {
      if (val) {
        this.init(val)
      }
    })

    this.route.queryParams.subscribe(params => {
      if (params['tab']) {
        this.initial_tab = params['tab'];
      }
    });
  }

  async init(uuid, init = true) {
    this.player_uuid = uuid;
    const rtn = await this.http.post("/admin/player/get/summary/all", { player_uuid: uuid, status: 1 });
    this.data = rtn['player']
    this.banks = rtn['bank']
    this.games = rtn['game']
    this.player_ids = rtn['player_ids']
    this.active_player_ids = rtn['active_player_ids']
    this.summary = rtn['summary']

    this.show_generate_code = rtn['show_generate_code'];
    this.sections = rtn['sections'];
    if (this.data.referral_code) {
      let cuurrentCompany: any = this.http.getSelecetdCompanyDetail()
      this.referral_rate = this.data.referral_rate ?? cuurrentCompany.referral_rate;
    }

    this.setting = rtn['setting'];
    // this.data = await this.http.post('/admin/player/get', {uuid});
    //   this.banks = await this.http.post("/admin/setting/bank/get");
    //   console.log(this.banks)
    // this.games = await this.http.post("/admin/setting/game/get", {status: 1});
    // this.player_ids = await this.http.post("/admin/player/id/get", {player_uuid: uuid});
    // this.active_player_ids = await this.http.post("/admin/player/id/get", {player_uuid: uuid, status: 1});
    // this.summary = await this.http.post("/admin/player/get/summary/all",  {player_uuid: uuid, status: 1, uuid});
    this.is_loading = false;
    setTimeout(() => {
      //this.initTable(this.player_uuid);
      if (init) {
        this.initForm();
      }
    }
      , 100);
  }

  async initForm() {
    const initData = { status: 1 };
    if (this.games.length > 0) {
      initData['game_id'] = this.games[0]['id']
    }
    this.playerForm.resetForm(initData);

    let initTransaction = { type: 'topup' }

    if (this.permission.game_integration) {
      initTransaction.type = "topup"
    }

    this.f.resetForm(initTransaction);
    this.transaction = { type: 'topup' };
    if (this.permission.game_integration) {
      this.transaction.type = "topup"
    }
    setTimeout(() => {
      this.initTransctionForm();
    }, 100)
  }

  initTransctionForm() {

    const type = this.transaction.type ? this.transaction.type : 'topup';
    this.transaction = { type }

    switch (type) {

      case 'wallet-adjustment':
      case 'profit-adjustment':
        this.transaction.method = 'debit'
        this.transaction.adjustment = 0;
        break;

      case 'transfer-to-game':
        if (this.games.length > 0) {
          this.transaction.game = this.games[0]['id']
        }
        break;

      case 'transfer-to-wallet':
        if (this.games.length > 0) {
          this.transaction.game = this.games[0]['id'];
          this.transaction.from_balance = 0;
        }
        break;

      case 'transfer':
        if (this.games.length > 0) {
          this.transaction.from_game = this.games[0]['id']
          this.transaction.to_game = this.games[0]['id']
          this.transaction.from_balance = 0;
        }
        break;

      case 'topup':
        if (this.banks.length > 0) {
          this.transaction.bank = this.banks[0]['id']
        }
        this.transaction.generate_voucher_code = false;
        break;

      case 'withdraw':
        if (this.banks.length > 0) {
          this.transaction.bank = this.banks[0]['id']
        }
        this.transaction.game_balance = 0;
        this.transaction.generate_voucher_code = false;
        break;
    }

  }

  async updateTransaction() {

    this.transaction_loading = true;
    const data = this.transaction;
    data.player_uuid = this.player_uuid
    const s = await this.http.post("/admin/player/transaction", data);
    if (s && s['status']) {
      this.is_loading = true;
      this.initForm();
      this.init(this.player_uuid, false);
    }
    this.transaction_loading = false;
  }

  async updatePlayerGameID() {
    const data = this.player_id_data;
    data.player_uuid = this.player_uuid
    await this.http.post("/admin/player/id/update", data);
    this.init(this.player_uuid);
  }


  editPlayer(player_data) {
    this.player_id_data = player_data;
  }

  clearPlayer() {

    const initData = { status: 1 };
    if (this.games.length > 0) {
      initData['game_id'] = this.games[0]['id']
    }
    this.player_id_data = initData;
    this.playerForm.resetForm(initData);
  }

  checkIfNegative() {
    // if(this.transaction.payment < 0 && this.transaction.type == 'topup') {
    //   this.transaction.payment = this.transaction.payment * -1  
    // }
  }

  calculateReferral() {
    this.transaction.referral_commission = (this.transaction.payment * this.referral_rate) / 100;

    if (this.setting.credit_calculation_method && this.setting.credit_calculation_method == 'auto') {
      this.transaction.point = (this.transaction.payment * parseFloat(this.setting.credit_calculation_rate)) / 100;
    }
  }

  makeid(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  generateVoucherCode() {
    if (this.transaction.generate_voucher_code === "true") {
      this.transaction.voucher_code = this.makeid(8);
    } else {
      delete this.transaction.voucher_code;
      delete this.transaction.voucher_value;
    }
  }

  enabledDeleteOfPlayer() {
    this.deletePlayerEnabled = !this.deletePlayerEnabled;
  }

  async deletePlayerID() {
    let match_ids_to_delete = this.player_ids.filter((v: any) => { return v.delete });

    if (match_ids_to_delete.length == 0) {
      this.deletePlayerEnabled = false;
      return;
    }

    let confirmed = prompt("You are about to delete player ID. Enter 'CONFIRM' in the textbox to confirm");

    if (confirmed != "CONFIRM") {
      alert("Player ID not delete.")
      this.deletePlayerEnabled = false;
      return;
    }

    await this.http.post("/admin/player/delete-player-game-id", { player_game_ids: match_ids_to_delete })
    await this.init(this.player_uuid);

    this.deletePlayerEnabled = false;

  }

  fcRateChange() {
    if (this.transaction.finance_charge == "true") {
      console.log("aaaaa")
      this.transaction.finance_charge_rate = this.setting.finance_charge_rate;
    } else {
      console.log("bbbb")
      delete this.transaction.finance_charge_rate
    }

  }
}
